import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import MarketingReveal from './MarketingReveal';
import { pageText } from '../../content/publicPages';
import { usePublicPage } from '../../hooks/usePublicPage';

/**
 * Peerspace-style host / vendor recruitment close.
 */
const MarketingHostCtaBand = () => {
  const { saved, defaults } = usePublicPage('home');
  return (
    <section className="bg-m-night px-4 py-20 text-m-on-dark sm:px-6 sm:py-28">
      <MarketingReveal className="mx-auto grid w-full max-w-6xl gap-10 lg:grid-cols-2 lg:items-center lg:gap-16">
        <div>
          <p className="mb-3 text-[11px] font-medium uppercase tracking-[0.14em] text-white/50">
            {pageText(saved.host_eyebrow, defaults.host_eyebrow)}
          </p>
          <h2 className="marketing-section-title mb-4 max-w-lg text-m-on-dark">
            {pageText(saved.host_title, defaults.host_title)}
          </h2>
          <p className="marketing-body-lg mb-8 max-w-md text-white/70">
            {pageText(saved.host_body, defaults.host_body)}
          </p>
          <div className="flex flex-col gap-3 sm:flex-row">
            <Link to={pageText(saved.host_primary_link, defaults.host_primary_link)} className="marketing-btn marketing-btn-ghost gap-2">
              {pageText(saved.host_primary_label, defaults.host_primary_label)}
              <ArrowRight className="h-4 w-4" />
            </Link>
            <Link
              to={pageText(saved.host_secondary_link, defaults.host_secondary_link)}
              className="inline-flex h-[var(--m-control-h)] items-center justify-center gap-2 rounded-full border border-white/25 px-6 text-sm font-medium text-white transition-colors hover:border-white/50"
            >
              {pageText(saved.host_secondary_label, defaults.host_secondary_label)}
            </Link>
          </div>
        </div>
        <div className="relative overflow-hidden rounded-[28px]">
          <img
            src={pageText(saved.host_image, defaults.host_image)}
            alt=""
            className="aspect-[16/11] w-full object-cover"
            loading="lazy"
          />
        </div>
      </MarketingReveal>
    </section>
  );
};

export default MarketingHostCtaBand;
